import type { ClassValue } from "clsx";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function toFilterId(value: string): string {
  const id = (value ?? "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return id || "unknown";
}

export function productTypeToFilterId(productType: string): string {
  return toFilterId(productType);
}

export function marketplaceToFilterId(marketplace: string): string {
  return toFilterId(marketplace);
}

export const titleCase = (value: string): string =>
  value.charAt(0) + value.slice(1).toLowerCase();
